<script lang="ts" setup>
withDefaults(
  defineProps<{
    color?: string;
    block?: boolean;
    disabled?: boolean;
    loading?: boolean;
    type?: 'button' | 'submit' | 'reset';
    variant?: 'flat' | 'outlined' | 'tonal' | 'text';
    outlined?: boolean;
    prependIcon?: string;
    size?: string;
    textNone?: boolean;
  }>(),
  {
    variant: 'flat',
    textNone: true,
  },
);
</script>

<template>
  <v-btn
    :block="block"
    :color="color"
    :disabled="disabled"
    :loading="loading"
    :size="size"
    :type="type"
    :variant="variant"
    :prepend-icon="prependIcon"
    :class="{
      'v-btn--variant-outlined': outlined,
      'text-none': textNone,
      'm-btn': true,
    }"
  >
    <slot />
  </v-btn>
</template>
